export default __webpack_public_path__ + "static/media/Columbian Financial.786e966f.svg";